$(document).ready(function(){
  function addToCartSuccess() {
    $.get( "/cart?view=mini", function( data ) {
      $('#crt').html(data);
    });
  }
  function refreshCart(cart) {
    $('.cart-count').text("("+cart.item_count+")");
  }
  
  $('body').on('click','.addtocart',function(e){ 
    console.log("clicked");
    e.preventDefault();
    var btn = $(this);
    // var variant_id = $(this).closest('.hw-product-banner__content').find('.hw-product-banner__content-wrap').attr('data-variant-id'); 
    var variant_id = $(this).attr('data-variant-id'); 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
          id:variant_id,
          quantity: 1
      },
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        btn.text('add to cart');
        btn.removeAttr('disabled');
      }
    }).done(function( data ) {
      addToCartSuccess();
      btn.text('add to cart');
      btn.removeAttr('disabled');
      $.getJSON('/cart.js', function(cart){
        refreshCart(cart);
      });
      $('.hw-side-cart').addClass('open');
    });

  });

  // $('body').on('click','.js-side-cart-close', function(e){
  //   e.preventDefault();
  //   $('.hw-side-cart').removeClass('open');
  // //   $('.fullPage').removeClass('witmenu');
  // //   $('body').removeClass('cartOpen');
  // });
  $('.cart_button').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').addClass('cartOpen');
      $('.fullPage').addClass('witmenu');
    }, 50);
  });

  $('body').on('click', '.adjust',function(){
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);

    $('#crt').addClass('loading');
    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        $('#crt').removeClass('loading');
      }
    }).done(function( data ) {
      addToCartSuccess();
      $.getJSON("/cart.js", function(cart) {
        refreshCart(cart);
      });
      $('#crt').removeClass('loading');
    });

  });



  $("body").on("click", "a.remove_item", function(e){
      e.preventDefault();
      var id = $(this).data("id");
      $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
          id: id,
          quantity:0
      },
      success: function(){
      $.getJSON('/cart.js', function(c){
          console.log(c , "data")
      $('.cart-drawer-btn').text('Cart'+' '+'('+c.item_count+')');
      refreshCart(c);
      });
      addToCartSuccess();
      }
      });
  });
  
  // if( typeof window.productTabsData !== "undefined" ) {
  //     let contentData = Array();
  //     $(window.productTabsData).find("ol").each((ix,em) => {
  //       let content = $(em).html();
  //       contentData[ix] = content;
  //     })

  //     $(contentData).each((ix,em) => {        
  //       $(".js-accordion-ui-panel").eq(ix).html(em);
  //       $(".js-accordion-ui-title").eq(ix).html($(window.productTabsData).find(`[href='#tab${ix+1}']`).html());
  //     });
  // }

  

});